// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FaUserCircle, FaBell, FaSearch } from 'react-icons/fa';
// import logo from '../assets/logo2.jpg';

// const Header = () => {
//     return (
//         <header className="h-20 bg-white border-b border-slate-100 sticky top-0 z-40 px-6 lg:px-10 flex items-center justify-between shadow-sm">
            
//             {/* 1. Left: Logo & Admin Branding */}
//             <div className="flex items-center">
//                 <Link to="/" className="flex items-center gap-4 group">
//                     <img 
//                         src={logo} 
//                         alt="Kanthasri Logo" 
//                         className="h-10 lg:h-14 w-auto object-contain transition-transform group-hover:scale-105" 
//                     />
//                     <div className="h-8 w-[1px] bg-slate-200 hidden md:block mx-2"></div>
//                     <div className="hidden md:flex flex-col leading-tight">
//                         <h1 className="text-md font-serif italic text-slate-900">Kanthasri</h1>
//                         <span className="text-[9px] uppercase tracking-[0.3em] text-slate-400 font-bold">Admin Panel</span>
//                     </div>
//                 </Link>
//             </div>

//             {/* 2. Right: Search & User Controls */}
//             <div className="flex items-center gap-4 lg:gap-8">
                
//                 {/* Search Bar - Aesthetic Admin Style */}
//                 <div className="hidden sm:flex items-center bg-slate-50 border border-slate-100 px-3 py-1.5 rounded-sm focus-within:border-amber-200 transition-all">
//                     <FaSearch className="text-slate-400 mr-2" size={12} />
//                     <input 
//                         type="text" 
//                         placeholder="Search products or orders..." 
//                         className="bg-transparent text-[11px] uppercase tracking-widest outline-none text-slate-600 placeholder:text-slate-300 w-48 lg:w-64"
//                     />
//                 </div>

//                 <div className="flex items-center gap-4 border-l border-slate-100 pl-4 lg:pl-8">
//                     {/* Notification Bell */}
//                     <button className="relative text-slate-400 hover:text-amber-700 transition-colors">
//                         <FaBell size={18} />
//                         <span className="absolute -top-1 -right-1 w-2 h-2 bg-rose-500 rounded-full border-2 border-white"></span>
//                     </button>

//                     {/* Admin Profile */}
//                     <Link to="/profile" className="flex items-center gap-3 group">
//                         <div className="hidden lg:flex flex-col items-end leading-none">
//                             <span className="text-[10px] font-bold text-slate-800 uppercase tracking-tighter">Super Admin</span>
//                             <span className="text-[9px] text-emerald-500 font-bold uppercase tracking-widest mt-0.5 flex items-center gap-1">
//                                 <span className="w-1 h-1 bg-emerald-500 rounded-full animate-pulse"></span> Active
//                             </span>
//                         </div>
//                         <div className="w-10 h-10 rounded-sm bg-slate-900 flex items-center justify-center text-white group-hover:bg-amber-700 transition-colors">
//                             <FaUserCircle size={22} />
//                         </div>
//                     </Link>
//                 </div>
//             </div>
//         </header>
//     );
// };

// export default Header;

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUserCircle, FaSignOutAlt, FaChevronDown } from 'react-icons/fa';
import { toast } from 'react-toastify';
import apiCall from '../helper/apiCall';
import logo from '../assets/logo2.jpg';

const Header = () => {
    const [showMenu, setShowMenu] = useState(false);
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            // Using your apiCall template
            const response = await apiCall('logoutUser', {});

            if (response.success) {
                toast.success("Logged out successfully");
                // Clear any local storage if used, then redirect
                navigate("/login");
            }
        } catch (error) {
            toast.error("Logout failed");
        }
    };

    return (
        <header className="h-20 bg-white border-b border-slate-100 sticky top-0 z-40 px-6 lg:px-10 flex items-center justify-between shadow-sm">
            
            {/* Left: Brand */}
            <div className="flex items-center">
                <Link to="/" className="flex items-center gap-4">
                    <img src={logo} alt="Kanthasri" className="h-10 lg:h-14 w-auto" />
                </Link>
            </div>

            {/* Right: User Profile & Logout */}
            <div className="relative">
                <div 
                    className="flex items-center gap-3 cursor-pointer group"
                    onClick={() => setShowMenu(!showMenu)}
                >
                    <div className="hidden lg:flex flex-col items-end leading-none">
                        <span className="text-[10px] font-bold text-slate-800 uppercase tracking-tighter">Super Admin</span>
                        <span className="text-[9px] text-emerald-500 font-bold uppercase mt-0.5">Active</span>
                    </div>
                    
                    <div className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center text-white group-hover:bg-amber-700 transition-colors">
                        <FaUserCircle size={22} />
                    </div>
                    <FaChevronDown size={10} className={`text-slate-400 transition-transform ${showMenu ? 'rotate-180' : ''}`} />
                </div>

                {/* Dropdown Menu */}
                {showMenu && (
                    <>
                        {/* Invisible backdrop to close menu when clicking outside */}
                        <div className="fixed inset-0 z-10" onClick={() => setShowMenu(false)}></div>
                        
                        <div className="absolute right-0 mt-2 w-48 bg-white border border-slate-100 shadow-xl rounded-sm z-20 py-2 animate-fadeIn">
                            <Link 
                                to="/profile" 
                                className="px-4 py-2 text-[11px] uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3"
                                onClick={() => setShowMenu(false)}
                            >
                                <FaUserCircle /> My Profile
                            </Link>
                            
                            <hr className="my-2 border-slate-50" />
                            
                            <button 
                                onClick={handleLogout}
                                className="w-full text-left px-4 py-2 text-[11px] uppercase tracking-widest text-rose-600 hover:bg-rose-50 font-bold flex items-center gap-3"
                            >
                                <FaSignOutAlt /> Sign Out
                            </button>
                        </div>
                    </>
                )}
            </div>
        </header>
    );
};

export default Header;